import { FileInput, FormGroup } from '@blueprintjs/core'
import React, { SFC } from 'react'

import { SyncIndicator } from './sync-indicator'
import { FieldAdapterProps, FileInputProps } from './types'
import {
  createFileNameValue,
  createHelperText,
  createLabelWithId,
  createRequiredLabel,
  getIntent,
  identity,
} from './utils'

export type Props = FieldAdapterProps<FileInputProps>

const FileInputAdapter: SFC<Props> = ({
  input,
  meta,
  type,
  helperText,
  disabled = false,
  inline,
  required,
  intent,
  label,
  enableSyncControl,
  translate = identity,
  // tslint:disable-next-line:no-empty
  onSyncChange = (fieldName: string, newValue: boolean) => {},
}) => {
  const { id, labelText } = createLabelWithId(input, label)
  const intentType = getIntent(meta, intent)
  const helperTextMessage = createHelperText(meta, helperText, translate)
  const labelInfo = createRequiredLabel(required, translate)
  const fileNameValue = translate(createFileNameValue(input))

  // TODO: Needs to be refactored => change to trigger for validate after sync change
  const handleSyncChange = (fieldName: string, newValue: boolean) => {
    onSyncChange(fieldName, newValue)
    const value = input.value
    input.onChange(' ') // trigger for validate
    window.setTimeout(() => input.onChange(value))
  }

  const reqLabelMod = (
    <>
      {labelInfo}
      {enableSyncControl && (
        <SyncIndicator
          translate={translate}
          fieldName={input.name}
          disabled={disabled}
          onSyncChange={handleSyncChange}
        />
      )}
    </>
  )

  return (
    <FormGroup
      className={labelInfo ? 'required' : ''}
      helperText={helperTextMessage}
      label={labelText}
      labelFor={id}
      labelInfo={reqLabelMod}
      intent={intentType}
      inline={inline}
      disabled={disabled}
    >
      <FileInput
        id={id}
        {...input}
        disabled={disabled}
        text={fileNameValue}
        // tslint:disable-next-line:jsx-no-lambda
        onChange={(e: any) => input.onChange(e.target.files[0])}
      />
    </FormGroup>
  )
}

export { FileInputAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/file-input-adapter.tsx